import { render, staticRenderFns } from "./accountButton.vue?vue&type=template&id=b923136a&scoped=true"
import script from "./accountButton.vue?vue&type=script&lang=js"
export * from "./accountButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b923136a",
  null
  
)

export default component.exports